import { deepMerge } from 'js/utils/Utils'
import { checkTagKind } from 'js/utils/Utils'

const defaults = {
  $name: {
    navItem: '[data-nav-group]',
    navGlobalItem: '[data-nav-group]',
  },
  className: {
    current: 'is-current',
  },
  dataName: {
    navPageType: 'navGroup',
    contentPageType: 'pageGroup',
  },
  isCurrentItemNoClick: true,
}

export default class PageCurrentChecker {
  constructor(options = {}) {
    this.$wrapper = document.body

    this.$navItemAll = []
    this.$navContentItemAll = []

    this.currentType = ''

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
  }

  _set$() {
    this.$navItemAll = this.$wrapper.querySelectorAll(this.$name.navGlobalItem)
  }

  pageEnter($content, useEase = true) {
    if ($content) {
      this.currentType = $content.dataset[this.dataName.contentPageType] || ''
      this.currentType = this.currentType.toLowerCase()

      this.$navContentItemAll = $content.querySelectorAll(this.$name.navItem)
    } else {
      this.$navContentItemAll = []
      this.currentType = ''
    }

    this.$navItemAll.forEach(($item) => {
      let navCurrentType = $item.dataset[this.dataName.navPageType] || null
      navCurrentType = navCurrentType.toLowerCase()

      if (navCurrentType === this.currentType) {
        this.addCurrent($item, useEase)
      } else {
        this.removeCurrent($item, useEase)
      }
    })

    this.$navContentItemAll.forEach(($item) => {
      let navCurrentType = $item.dataset[this.dataName.navPageType] || null
      navCurrentType = navCurrentType.toLowerCase()

      if (navCurrentType === this.currentType) {
        this.addCurrent($item, useEase, true)
      } else {
        this.removeCurrent($item, useEase, true)
      }
    })
  }

  pageLeave() {
    if (this.$navItemAll && this.$navItemAll.length) {
      this.$navItemAll.forEach(($item) => {
        if ($item) {
          this.removeCurrent($item)
        }
      })
    }
  }

  addCurrent($item, useEase = true) {
    if ($item) {
      $item.classList.add(this.className.current)

      // if (this.isCurrentItemNoClick) {
      //   const isLinkTag = checkTagKind($item, 'a') || checkTagKind($item, 'button')
      //
      //   if (isLinkTag) {
      //     $item.tabIndex = -1
      //   } else {
      //     const $link = $item.querySelector('a') || $item.querySelector('button')
      //     if ($link) {
      //       $link.tabIndex = -1
      //     }
      //   }
      // }
    }
  }

  removeCurrent($item, useEase = true) {
    if ($item) {
      $item.classList.remove(this.className.current)

      // if (this.isCurrentItemNoClick) {
      //   const isLinkTag = checkTagKind($item, 'a') || checkTagKind($item, 'button')
      //
      //   if (isLinkTag) {
      //     $item.tabIndex = ''
      //   } else {
      //     const $link = $item.querySelector('a') || $item.querySelector('button')
      //     if ($link) {
      //       $link.tabIndex = ''
      //     }
      //   }
      // }
    }
  }
}